import React from "react";
import TwitterIcon from "@mui/icons-material/Twitter";

import "./NavMobile.scss";
import { Avatar } from "@mui/material";
import { useUserAuth } from "../../context/userAuthContext";
import useLoggedinUser from "../../hooks/useLoggedinUser";

const NavMobile = ({ setShow }) => {
  const [loggedinUser] = useLoggedinUser();
  const { user } = useUserAuth();

  return (
    <nav className="nav-mobile">
      <TwitterIcon className="twitterIcon" />
      <Avatar
        src={
          loggedinUser[0]?.profileImage
            ? loggedinUser[0]?.profileImage
            : user && user.photoURL
        }
        onClick={() => {
          setShow((prev) => !prev);
        }}
      />
    </nav>
  );
};

export default NavMobile;
